import { isUndefined } from 'util';
import { Evaluation, IEvaluation } from '../services/GI.Web.Services.g';
import { PeriodStatuses } from './periodStatus';

/** Extended version of the Evaluation DTO which has calculated properties for binding in the UI */
export class EvaluationModel extends Evaluation {
    public get periodStatus(): string {
        const now = new Date(Date.now());
        if (this.start <= now && this.end >= now) {
            return PeriodStatuses.active;
        }
        if (this.end < now) {
            return PeriodStatuses.completed;
        }
        return PeriodStatuses.notStarted;
    }

    public get interactiveCreditsAvailable(): number {
        if (!isUndefined(this.interactiveCredits) && !isUndefined(this.interactiveCreditsUsed)) {
            return this.interactiveCredits - this.interactiveCreditsUsed;
        }
        return 0;
    }

    constructor(evaluation?: IEvaluation) {
        super(evaluation);
        this.clients = this.clients || [];
        this.users = this.users || [];
        this.displayName = this.displayName || this.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/evaluation-model.ts